module.exports = __webpack_public_path__ + "img/专利授权数.b186ee2f.png";